<template><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<polygon style="fill:#F8F8F9;" points="345.6,0 51.2,0 51.2,512 460.8,512 460.8,115.2 "/>
<polygon style="fill:#EDEDED;" points="345.6,115.2 345.6,0 256,0 256,512 460.8,512 460.8,115.2 "/>
<rect x="51.2" y="230.4" style="fill:#E07188;" width="409.6" height="204.8"/>
<rect x="256" y="230.4" style="fill:#E02753;" width="204.8" height="204.8"/>
<g>
	<path style="fill:#F8F8F9;" d="M232.727,324.429V371.2h-18.89v-81.792h14.746l38.131,48.038v-48.038h18.894V371.2H270.4
		L232.727,324.429z"/>
	<path style="fill:#F8F8F9;" d="M136.308,371.2v-81.792h34.904c15.09,0,26.726,13.952,26.726,27.649
		c0,15.744-11.796,27.763-26.15,27.763H155.2v26.38H136.308z M155.201,328.346h15.437c5.025,0,8.179-4.905,8.179-11.288
		c0-6.577-3.474-11.059-8.87-11.059H155.2v22.348H155.201z"/>
	<path style="fill:#F8F8F9;" d="M363.249,363.136c-6.221,5.76-13.403,8.64-21.542,8.64c-22.506,0-39.283-18.496-39.283-42.049
		c0-23.808,18.938-40.895,40.781-40.895c16.091,0,26.996,7.127,32.718,17.855l-14.054,10.598
		c-4.426-8.006-11.466-11.635-19.354-11.635c-11.633,0-20.966,10.349-20.966,24.769c0,13.74,8.854,24.538,21.772,24.538
		c7.375,0,14.016-3.418,19.931-10.254v-2.533h-15.899v-13.71h31.566v42.74H363.25v-8.064H363.249z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg></template>

<script>
export default {}
</script>